import {
  insurance,
  insuranceType,
} from "app/services/AdminServices/bookingService";
import moment from "moment";
import Tooltip from "rc-tooltip";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { FaLongArrowAltRight } from "react-icons/fa";

export default function Insurance({ show, modalClose, response }) {
  const [data, setData] = useState("");
  const [selectedPlan, setSelectedPlan] = useState(null);

  const handleSelectChange = (event) => {
    // debugger;
    const selectedValue = event.target.value;
    const selectedItem = data.find(
      (item) => item.planDisplayText == selectedValue
    );
    setSelectedPlan(selectedItem);
    // console.log(selectedItem);
  };
  const insuranceData = async () => {
    // debugger;
    const response = await insuranceType();
    setData(response?.data?.data);
    // console.log(response);
  };
  useEffect(() => {
    if (show == true) {
      insuranceData();
    }
  }, [show == true]);

  // console.log(response);

  const insuranceSubmit = async (response) => {
    // debugger;
    const data = {
      customerdetails: {
        email: response.user.email,
        nationality: "IN",
        mobile: "1234567890",
      },
      traveldetails: {
        departurecity: response?.airportDeparture?.cityName,
        destinationcity: response?.airportDestination?.cityName,
        destinationcountry: response?.airportDestination?.countryCode,
        journeystartdate: response?.departureDate,
        journeyenddate: response?.arrivalDate,
      },
      travelers: response.passengerList.map((passenger, index) => {
        return {
          firstname: passenger.firstName,
          lastname: passenger.lastName,
          gender: passenger.gender,
          dob: passenger.birthDate,
          passport: passenger.passport,
        };
      }),

      insurancedetails: {
        traveltype: "Package",
        insurancetype: selectedPlan?.planDisplayText[0],
        totalpayble: selectedPlan?.planCost[0],
      },
      bookingdetails: {
        bookingid: response?.bookingId,
        bookingproof: [
          {
            filename: "",
            contents: "",
            filetype: "",
          },
        ],
      },
    };
    const insuranceRes = await insurance(data);
    // console.log(insuranceRes);
    modalClose();
  };

  return (
    <div>
      <Modal size={"xl"} show={show} onHide={modalClose}>
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              // justifyContent: "center",
              // display: "flex",
              fontSize: 30,
              fontWeight: "bold",
            }}
          >
            Insurance
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              // justifyContent: "center",
              // display: "flex",
              fontSize: 18,
              fontWeight: "bold",
            }}
          >
            <span style={{ cursor: "pointer" }}>
              {response?.airportDeparture?.cityName}
            </span>{" "}
            <FaLongArrowAltRight />{" "}
            <span style={{ cursor: "pointer" }}>
              {response?.airportDestination?.cityName}
            </span>
          </div>
          {/* <span
            style={{
              fontSize: "22px",
              marginBottom: "10px",
              fontWeight: "bold",
            }}
          >
            Passenger Details :
          </span> */}
          <div>
            <div className="col-12">
              <table className="table table-striped border text-center table-inverse">
                <thead className="thead-inverse  bg-primary text-white">
                  <tr>
                    {/* <th scope="col">Title</th> */}
                    <th scope="col">Full Name</th>
                    {/* <th scope="col">Last Name</th> */}

                    <th scope="col">PNR</th>
                    <th>Date of Birth</th>
                    {response?.isDomestic == false && (
                      <>
                        <th scope="col">Passport No.</th>
                        <th scope="col">Passport Issue Date</th>
                        <th scope="col">Passport Expiry Date</th>
                        <th scope="col">Passport Nationality</th>
                      </>
                    )}
                  </tr>
                </thead>

                <tbody className="text-center">
                  {response?.passengerList?.map((passenger, id) => (
                    <tr key={id}>
                      {/* <td scope="row">{passenger?.title}</td> */}
                      <td>
                        {passenger?.title} {passenger?.firstName}{" "}
                        {passenger?.lastName} ({passenger?.passengerType})
                      </td>
                      {/* <td>{passenger?.lastName}</td> */}
                      <td>
                        {passenger?.pnr != null ? (
                          <>
                            <Tooltip
                              placement="right"
                              overlay={<div>{passenger?.pnr}</div>}
                            >
                              <span style={{ cursor: "pointer" }}>
                                {passenger?.pnr.substring(0, 12) + "..."}
                              </span>
                            </Tooltip>
                          </>
                        ) : (
                          "Not Available"
                        )}
                      </td>
                      <td>
                        {passenger?.birthDate?.length > 0
                          ? passenger.birthDate
                          : "Not available"}
                      </td>

                      {response.isDomestic == false && (
                        <>
                          <td>
                            {passenger?.passport != null
                              ? passenger?.passport
                              : "Not Available"}
                          </td>
                          <td>
                            {passenger?.passportIssueDate != null
                              ? moment(passenger?.passportIssueDate).format(
                                  "DD-MM-YYYY"
                                )
                              : "Not Available"}
                          </td>
                          <td>
                            {passenger?.passportExpiryDate != null
                              ? moment(passenger?.passportExpiryDate).format(
                                  "DD-MM-YYYY"
                                )
                              : "Not Available"}
                          </td>
                          <td>
                            {passenger?.passportNationality != null
                              ? passenger?.passportNationality
                              : "Not Available"}
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <Row>
            <Col
              style={{
                fontSize: 15,
              }}
            >
              Insurance Type :
            </Col>
          </Row>
          <Row>
            <Col>
              <select className="form-control" onChange={handleSelectChange}>
                <option value={""}>Please Select Insurance Type</option>
                {data ? (
                  data.map((item, index) => {
                    return (
                      <option key={index} value={item.planDisplayText}>
                        {item.planDisplayText}
                      </option>
                    );
                  })
                ) : (
                  <>
                    <option value={""}>Please wait...</option>
                  </>
                )}
              </select>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={modalClose}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => insuranceSubmit(response)}
            disabled={data == "" || selectedPlan == undefined ? true : false}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
